module.exports = __webpack_public_path__ + "static/media/clock.087ffda6.svg";